import React, { useRef, useState } from 'react';
import { Slider } from '@mui/material';
import PauseIcon from '@mui/icons-material/PauseCircleOutlined';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import PlaybackSpeed from '@mui/icons-material/ScheduleOutlined';
import FullScreen from '@mui/icons-material/ZoomOutMapOutlined';
import Stack from '@mui/material/Stack';
import cx from 'classnames';
import MuteIcon from '@mui/icons-material/VolumeMute';

import PlayIcon from '../../../../assets/icons/play-icon-timeline.svg';
import ExitFullScreen from '../../../../assets/icons/exit-full-screen.svg';
import VolumeIcon from '../../../../assets/icons/volume-icon.svg';
import styles from './VideoControls.module.scss';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { timeLineFormatTime } from '../../../../helpers/timelineFormatTime';
import NotesForVideo from '../../NotesForVideo';
import { updateShowNotes } from '../../../../store/sharedStore/sharedStoreSlice';
import VideoQualitySelector from '../../VideoQualitySelector';
import qualityMenuStyles from '../../VideoQualitySelector/VideoQualitySelector.module.scss';
import { VIDEO_TYPE } from '../../../../enums';
import useOnClickOutside from '../../../../helpers/useOnClickOutside';

type TVideoControls = {
  played: number;
  onPlayPause: (imperativePlay?: boolean) => void;
  onSeek: (event: Event, value: number | number[], activeThumb: number) => void;
  onSeekMouseUp: (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]) => void;
  currentTime: string | number;
  onMouseSeekDown: () => void;
  controlRef: React.MutableRefObject<HTMLDivElement | null>;
  playing: boolean;
  fullScreenHandler: () => void;
  activeFullScreen: boolean;
  changePlayBackRate: (rate: number) => void;
  videoVolumeChange: (volume: number) => void;
  volume: number;
  playBackRate: number;
  videoData: VIDEO_TYPE;
};

const VideoControls: React.FC<TVideoControls> = ({
  played,
  onPlayPause,
  onSeek,
  onSeekMouseUp,
  currentTime,
  onMouseSeekDown,
  controlRef,
  playing,
  fullScreenHandler,
  activeFullScreen,
  changePlayBackRate,
  videoVolumeChange,
  volume,
  playBackRate,
  videoData,
}) => {
  const [speedAnchor, setAnchorForSpeedOption] = React.useState<null | HTMLElement>(null);
  const dispatch = useAppDispatch();
  const { videoLength, videoControls } = useAppSelector((state) => state.videoStore);
  const { showNotes } = useAppSelector((state) => state.sharedStore);

  const switchPlaybackOptionsMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorForSpeedOption(speedAnchor ? null : event.currentTarget);
  };
  const speedOptionMenuRef = useRef<HTMLDivElement | null>(null);

  const [showFullScreenSpeedOption, setShowFullScreenSpeedOption] = useState(false);
  const showFullScreenSpeedOpitonMenu = () => {
    setShowFullScreenSpeedOption(!showFullScreenSpeedOption);
  };

  const closeFullScreenSpeedOptionMenu = () => {
    setShowFullScreenSpeedOption(false);
  };
  useOnClickOutside(speedOptionMenuRef, (e) => {
    e.stopPropagation();
    setAnchorForSpeedOption(null);
    closeFullScreenSpeedOptionMenu();
  });

  const open = Boolean(speedAnchor);
  const id = open ? 'simple-popper' : undefined;

  const selectSpeed = (e: React.MouseEvent<HTMLDivElement>) => {
    changePlayBackRate(Number(e.currentTarget.id));
    setAnchorForSpeedOption(null);
  };

  const [showVolume, setShowVolume] = useState(false);
  const handleVolumeChange = (event: Event, newValue: number | number[]) => {
    videoVolumeChange((newValue as number) / 100);
  };

  const showVolumeSlider = () => {
    setShowVolume(true);
  };

  const closeVolumeSlider = () => {
    setShowVolume(false);
  };

  const switchFullScreen = () => {
    fullScreenHandler();
    setAnchorForSpeedOption(null);
    setShowFullScreenSpeedOption(false);
  };

  const muteSwitch = () => {
    videoVolumeChange(videoControls.volume > 0 ? 0 : 1);
  };

  const switchShowNotes = () => {
    dispatch(updateShowNotes(!showNotes));
  };

  return (
    <div ref={controlRef} className={styles.controls}>
      {!activeFullScreen ? (
        <></>
      ) : (
        // <div className={styles.rangeWrapper}>
        //   <div className={styles.secondsPlayed}>
        //     {playing ? (
        //       <PauseIcon onClick={() => onPlayPause()} className={styles.pauseIcon} />
        //     ) : (
        //       <img onClick={() => onPlayPause()} className={styles.playIcon} src={PlayIcon} alt="play video" />
        //     )}
        //     {currentTime} / {timeLineFormatTime(videoLength)}
        //   </div>
        //   <Slider
        //     min={0}
        //     max={100}
        //     value={played * 100}
        //     onChange={onSeek}
        //     onChangeCommitted={onSeekMouseUp}
        //     onMouseDown={onMouseSeekDown}
        //     sx={{
        //       '& .MuiSlider-thumb': {
        //         display: 'none',
        //       },
        //       '& .MuiSlider-rail': {
        //         color: 'black',
        //         height: '7px',
        //       },
        //       '& .MuiSlider-track': {
        //         color: 'white',
        //         height: '8px',
        //       },
        //     }}
        //   />

        //   <div className={styles.volumeContainer} onMouseEnter={showVolumeSlider} onMouseLeave={closeVolumeSlider}>
        //     {showVolume && (
        //       <div className={styles.volumeSlider}>
        //         <Box sx={{ height: 200 }}>
        //           <Stack spacing={2} sx={{ mb: 1 }} alignItems="center">
        //             <Slider
        //               orientation="vertical"
        //               color="secondary"
        //               aria-label="Volume"
        //               value={volume * 100}
        //               valueLabelDisplay="auto"
        //               onChange={handleVolumeChange}
        //               sx={{
        //                 height: 100,
        //                 '& .MuiSlider-thumb': {
        //                   display: 'none',
        //                 },
        //                 '& input[type="range"]': {
        //                   WebkitAppearance: 'slider-vertical',
        //                 },
        //               }}
        //             />
        //           </Stack>
        //         </Box>
        //       </div>
        //     )}
        //     <div onClick={muteSwitch} className={styles.volumeButton}>
        //       {videoControls.volume > 0 ? <img src={VolumeIcon} alt="volume" /> : <MuteIcon className={styles.muteIcon} />}
        //     </div>
        //   </div>

        //   <div className={styles.playSpeedIcon} aria-describedby={id} onClick={switchPlaybackOptionsMenu}>
        //     <PlaybackSpeed sx={{ height: '24px' }} />
        //   </div>
        //   <Popper ref={speedOptionMenuRef} placement={'top'} id={id} open={open} anchorEl={speedAnchor} sx={{ zIndex: 3 }}>
        //     <Box
        //       sx={{
        //         textAlign: 'center',
        //         cursor: 'pointer',
        //         color: 'white',
        //         borderRadius: '8px',
        //         marginBottom: '10px',
        //         background: '#1f1f1f',
        //       }}
        //     >
        //       <div onClick={selectSpeed} id="0.25" className={cx(styles.speedOption, playBackRate === 0.25 && styles.activeSpeedOption)}>
        //         0.25
        //       </div>
        //       <div onClick={selectSpeed} id="0.5" className={cx(styles.speedOption, playBackRate === 0.5 && styles.activeSpeedOption)}>
        //         0.5
        //       </div>
        //       <div onClick={selectSpeed} id="0.75" className={cx(styles.speedOption, playBackRate === 0.75 && styles.activeSpeedOption)}>
        //         0.75
        //       </div>
        //       <div onClick={selectSpeed} id="1.0" className={cx(styles.speedOption, playBackRate === 1 && styles.activeSpeedOption)}>
        //         Normal
        //       </div>
        //       <div onClick={selectSpeed} id="1.25" className={cx(styles.speedOption, playBackRate === 1.25 && styles.activeSpeedOption)}>
        //         1.25
        //       </div>
        //       <div onClick={selectSpeed} id="1.5" className={cx(styles.speedOption, playBackRate === 1.5 && styles.activeSpeedOption)}>
        //         1.5
        //       </div>
        //       <div onClick={selectSpeed} id="2" className={cx(styles.speedOption, playBackRate === 2 && styles.activeSpeedOption)}>
        //         2
        //       </div>
        //     </Box>
        //   </Popper>

        //   <div className={styles.qualityWrapper}>
        //     <VideoQualitySelector videoData={videoData} />
        //   </div>

        //   <div onClick={switchFullScreen} className={styles.fullScreenIcon}>
        //     <FullScreen sx={{ height: '24px' }} />
        //   </div>
        // </div>
        // full screen controls
        <div className={styles.fullScreen}>
          <NotesForVideo
            className={showNotes ? styles.notes : styles.hiddenNotes}
            switchShowNotes={switchShowNotes}
            showNotes={showNotes}
          />
          <div className={styles.fullScreenControls}>
            <div className={styles.leftSide}>
              <div className={styles.secondsPlayed}>
                {playing ? (
                  <PauseIcon onClick={() => onPlayPause()} className={styles.pauseIcon} />
                ) : (
                  <img onClick={() => onPlayPause()} className={styles.playIcon} src={PlayIcon} alt="play video" />
                )}
                {currentTime} / {timeLineFormatTime(videoLength / 1000)}
              </div>
            </div>

            <div className={styles.rightSide}>
              <div className={styles.volumeContainer} onMouseEnter={showVolumeSlider} onMouseLeave={closeVolumeSlider}>
                {showVolume && (
                  <div className={styles.volumeSlider}>
                    <Box sx={{ width: 200, marginTop: '-3px' }}>
                      <Stack spacing={2} sx={{ mb: 1 }} alignItems="center">
                        <Slider
                          color="secondary"
                          aria-label="Volume"
                          value={volume * 100}
                          onChange={handleVolumeChange}
                          sx={{
                            '& .MuiSlider-thumb': {
                              display: 'none',
                            },
                          }}
                        />
                      </Stack>
                    </Box>
                  </div>
                )}
                <div onClick={muteSwitch} className={styles.volumeButton}>
                  {videoControls.volume > 0 ? <img src={VolumeIcon} alt="volume" /> : <MuteIcon className={styles.muteIcon} />}
                </div>
              </div>

              <div ref={speedOptionMenuRef} onClick={showFullScreenSpeedOpitonMenu} className={styles.fullScreenSpeedOptionWrapper}>
                {showFullScreenSpeedOption && (
                  <Box
                    className={qualityMenuStyles.playbackMenu}
                    sx={{
                      color: 'white',
                      marginBottom: '20px',
                      position: 'absolute',
                      bottom: '15px',
                      right: '-10px',
                    }}
                    onMouseLeave={closeFullScreenSpeedOptionMenu}
                  >
                    <div
                      onClick={selectSpeed}
                      id="0.25"
                      className={cx(qualityMenuStyles.option, playBackRate === 0.25 && qualityMenuStyles.selectedOption)}
                    >
                      0.25
                    </div>
                    <div
                      onClick={selectSpeed}
                      id="0.5"
                      className={cx(qualityMenuStyles.option, playBackRate === 0.5 && qualityMenuStyles.selectedOption)}
                    >
                      0.5
                    </div>
                    <div
                      onClick={selectSpeed}
                      id="0.75"
                      className={cx(qualityMenuStyles.option, playBackRate === 0.75 && qualityMenuStyles.selectedOption)}
                    >
                      0.75
                    </div>
                    <div onClick={selectSpeed} id="1.0" className={cx(qualityMenuStyles.option, playBackRate === 1 && qualityMenuStyles.selectedOption)}>
                      Normal
                    </div>
                    <div
                      onClick={selectSpeed}
                      id="1.25"
                      className={cx(qualityMenuStyles.option, playBackRate === 1.25 && qualityMenuStyles.selectedOption)}
                    >
                      1.25
                    </div>
                    <div
                      onClick={selectSpeed}
                      id="1.5"
                      className={cx(qualityMenuStyles.option, playBackRate === 1.5 && qualityMenuStyles.selectedOption)}
                    >
                      1.5
                    </div>
                    <div onClick={selectSpeed} id="2" className={cx(qualityMenuStyles.option, playBackRate === 2 && qualityMenuStyles.selectedOption)}>
                      2
                    </div>
                  </Box>
                )}
                <div className={styles.playSpeedIcon}>
                  <PlaybackSpeed />
                </div>
              </div>
              <div className={styles.qualityWrapper}>
                <VideoQualitySelector videoData={videoData} />
              </div>
              <div onClick={switchFullScreen} className={styles.exitFullScreenIcon} onMouseEnter={closeFullScreenSpeedOptionMenu}>
                <img src={ExitFullScreen} alt="exit full screen" />
              </div>
            </div>
          </div>
          <div className={styles.fullScreenVideoRange}>
            <Slider
              min={0}
              max={100}
              value={played * 100}
              onChange={onSeek}
              onChangeCommitted={onSeekMouseUp}
              onMouseDown={onMouseSeekDown}
              sx={{
                '& .MuiSlider-thumb': {
                  display: 'none',
                },
                '& .MuiSlider-rail': {
                  color: 'black',
                  height: '7px',
                },
                '& .MuiSlider-track': {
                  color: 'white',
                  height: '8px',
                },
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoControls;
